import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ReportService {
  private subject = new Subject<any>();
  private pdfReportSubject = new Subject<any>();

  private serviceUrl = environment.API_URL + 'report/activity';

  constructor(private _httpClient: HttpClient, private _translateService: TranslateService) { }

  toonPdfRapport(activiteitId: number, reportTitle: string, reportName: string, cloudReport: boolean = false, loadingMessage: string = this._translateService.instant('ALGEMEEN.RAPPORT_WORDT_OPGEHAALD')) {
    this.pdfReportSubject.next({ activiteitId: activiteitId, reportTitle: reportTitle, reportName: reportName, loadingMessage: loadingMessage, cloudReport: cloudReport })
  }

  showPdfReport(): Observable<any> {
    return this.pdfReportSubject.asObservable();
  }

  downloadReportByHash(hash: string): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/cloud/' + hash);
  }

  downloadPdfReport(reportName: string, id: number): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/' + reportName + '/' + id, {
      responseType: 'blob',
      reportProgress: true,
      observe: "events"
    });
  }

  downloadCloudPdfReport(id: number): Observable<any> {
    return this._httpClient.get(this.serviceUrl + '/download/' + id);
  }

}
